import React, { useState, useEffect } from "react";
// import { ThemeProvider } from "@mui/material/styles";
// import { Input } from "mdb-ui-kit"; // module
import "mdb-ui-kit/css/mdb.min.css";
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import "./Styles/UserBranchRoleForm.css";
import axios from "axios";
import ApiSettings from "../../../../../Settings/ApiSettings.json";

import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Cookies from "universal-cookie";
import { Box, Checkbox, FormControl, FormControlLabel, FormGroup, FormHelperText, FormLabel } from "@mui/material";
const cookies = new Cookies();
// export interface State extends SnackbarOrigin {
//   open: boolean;
// }
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function UserBranchRoleForm(props) {
  console.log("UserBranchRoleForm props", props);
  const [userBranchRolesSelected, setUserBranchRolesSelected] = useState([]);
  const [branch, setBranch] = useState({});
  const [userBranchList, setUserBranchList] = useState(props?.userBranchList)
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!cookies.get("role_id")) {
      window.location.href = "/";
    }
  }, []);

  const [roles, setRoles] = useState([]);

  //   const [openSnackbar, setopenSnackbar] = useState(false);
  const [snackBar, setsnackBar] = useState({
    open: false,
    vertical: "bottom",
    horizontal: "center",
    message: "",
    severity: "",
  });
  const { vertical, horizontal, open } = snackBar;


  useEffect(() => {

    setUserBranchList(props?.userBranchList)
  }, [props.userBranchList]);


  //handle open snackbar ....
  const handleClick = () => {
    setsnackBar({ open: true, ...snackBar });
  };
  //handle clode snackbar
  const handleClose = () => {
    setsnackBar({ ...snackBar, open: false });
  };

  const handleInputChange = (event, role) => {
    const target = event.target;
    // console.log("ischecked",target.checked);
    var tempUserBranchRolesSelected = userBranchRolesSelected
    if (target.checked) {
      tempUserBranchRolesSelected = [...userBranchRolesSelected, {
        id:role?.pivot?.id,
        branch_name:branch?.name,
        role_name:role?.name
      }]
    }
    else {
       tempUserBranchRolesSelected = userBranchRolesSelected.filter(function (item) {
        return item.id !== role?.pivot?.id
      })
      
    }
    setUserBranchRolesSelected(tempUserBranchRolesSelected)
    props?.setRows([...props?.rows.filter(row=>!userBranchRolesSelected.filter(selected=>selected?.id===row?.id).length>0),...tempUserBranchRolesSelected])
  };


  return (
    <div
      className={`ModalFormContainer rounded-3 px-2 ${props.inactive === false ? "activeSideMenu" : ""
        }`}
    >
      {/* header of form section  */}
      <div className="container-lg py-4 px-2 ">
        <div className="row">
          <div className="col-md-12 ">
            <div className="toSection d-flex justify-content-center align-items-center">
              <span className="FormName">المسميات الوظيفية للفرع</span>
            </div>
          </div>
        </div>
      </div>

      {/* section1 here...  */}
      <div className="section1 container-lg py-4 px-2 pe-4">
        <div className="row">
          <div className="col-md-12 align-items-center  d-flex " style={{
            flexDirection: 'column',
            borderStyle: 'solid',
            borderColor: 'rgb(95, 123, 138)',
            borderWidth: '2px',
            borderRadius: '10px',
            paddingTop: '10px',
            paddingBottom: '10px'
          }}>

            <FormControl sx={{ m: 3 }} component="fieldset" variant="standard">
              <FormGroup>
                <Autocomplete
                  // value={value}
                  onChange={(event, newValue) => {
                    // setValue(newValue);
                    console.log("newValue", newValue);

                    if(newValue && newValue.roles)
                    {
                      console.log("newValue.roles",newValue.roles);
                      var collectSelectedRoles=[]
                      newValue?.roles?.map((role,index)=>{

                        if(props?.rows?.filter(row=>row.id===role?.pivot?.id)?.length>0)
                        {
                          collectSelectedRoles.push({
                            id:role?.pivot?.id,
                            branch_name:newValue?.name,
                            role_name:role?.name
                          })
                        }

                      })
                      setUserBranchRolesSelected(collectSelectedRoles)
                      setRoles(newValue?.roles)

                    }
                    else{
                      setRoles([])
                    }
                    setBranch(newValue)
                  }}
                  // inputValue={inputValue}
                  getOptionLabel={(option) => option.name}
                  renderOption={(props, option) => (
                    
                    <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
                      {option.name} 
                    </Box>
                  )}
                  id="controllable-states-demo"
                  options={userBranchList}
                  sx={{ width: 300 }}
                  renderInput={(params) => <TextField {...params} label="اختر فرع" />}
                />
              </FormGroup>
              <FormLabel component="legend">اختر من المسميات الوظيفية التالية</FormLabel>
              <FormGroup>
                {roles.map((role, index) => {
                  var isChecked = false;
                  if (userBranchRolesSelected.length > 0 && userBranchRolesSelected.filter(selectedRole=>selectedRole?.id === role?.pivot?.id)?.length>0) {
                    isChecked = true;
                  }
                  return <FormControlLabel
                    key={index + "_branch_role"}
                    control={
                      <Checkbox checked={isChecked} onChange={(e) => handleInputChange(e, role)} name="gilad" />
                    }
                    label={role.name}
                  />
                })}

              </FormGroup>
              <FormHelperText>تستطيع اختيار اكثر من واحدة</FormHelperText>
            </FormControl>




            <Button
              variant="contained"
              className="mx-3 section1CarrerName section1Button mt-4 pt-1"
              onClick={() => {
                props?.setOpen(false)
              }}
            >
              {!loading ? (
                "اضافة"
              ) : (
                <div className="spinner-border " role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              )}
            </Button>

          </div>
        </div>
      </div>
      {/* snack alert box here ... */}
      <Snackbar
        open={snackBar.open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical, horizontal }}
      >
        <Alert
          onClose={handleClose}
          severity={snackBar.severity}
          sx={{ width: "100%" }}
        >
          {snackBar.message}
        </Alert>
      </Snackbar>
    </div>
  );
}
